import { render, staticRenderFns } from "./AffiliationsTaskMessages.vue?vue&type=template&id=8a80a9de&scoped=true&"
import script from "./AffiliationsTaskMessages.vue?vue&type=script&lang=js&"
export * from "./AffiliationsTaskMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a80a9de",
  null
  
)

export default component.exports